import React from 'react';

function Detail() {
  return <></>;
}

export default Detail;
